import { render, staticRenderFns } from "./ListAsetDilelangPage.vue?vue&type=template&id=15135e35"
import script from "./ListAsetDilelangPage.vue?vue&type=script&lang=js"
export * from "./ListAsetDilelangPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports